import { Suspense } from 'react';
import { LoadingOverlay } from '@mantine/core';
import useMainRoutes from './routes/router';

function App() {
  const routes = useMainRoutes();

  return (
    <Suspense fallback={<LoadingOverlay visible overlayProps={{ blur: 2 }} />}>{routes}</Suspense>
  );
}

export default App;
